module.exports = __webpack_public_path__ + "static/img/sm_17.a1ff5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_17.png
// module id = kFXo
// module chunks = 0